import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=4f6e3c44"
import script from "./RegionForm.vue?vue&type=script&lang=ts"
export * from "./RegionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports